// @flow

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Amplify from "aws-amplify";
import config from "./aws-exports";
import AuthWrapper from "./components/Auth/AuthWrapper.react";
import { AppErrorBoundary } from "./components/ErrorBoundaries.react";
import "@aws-amplify/ui-react/styles.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://479e1a2b88f7a523e3c947ff63c54b82@o4511354460372992.ingest.us.sentry.io/4511354464960512",
  environment: process.env.NODE_ENV,
});

// Temporarily disable Amplify's native OAuth support by passing on a blank object (Might use this feature in the future)

Amplify.configure({
  ...config,
  oauth: {},
});

ReactDOM.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthWrapper />
    </AppErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
